import View from '~/app/View'

// Cover
import HomepageCover from '~/components/homepage/homepage-cover'

// Top feature
import Hero from '~/components/homepage/hero'
// import 'components/homepage/logo-marquee'
import ImageLinkSlider from '~/components/global/image-link-slider'

// Product animation slider
import ProductAnimationSlider from '~/components/homepage/product-animation-slider'

// Product slider
// import 'components/global/product-slider'
import ProductSliderHomepage from '~/components/homepage/product-slider-homepage'

// Hero w/text
import HeroText from '~/components/homepage/hero-text'

// Split module
import SplitModule from '~/components/homepage/split-module'

import CollectionTabSlider from '~/components/homepage/homepage-collection-tab-slider'

const homepageView = new View()
homepageView.init({
  HomepageCover,
  Hero,
  ImageLinkSlider,
  ProductAnimationSlider,
  ProductSliderHomepage,
  HeroText,
  SplitModule,
  CollectionTabSlider,
})
